export default "__VITE_ASSET__CGJV1$O4__"